<template>
  <div class="list-common"
       :id="printId">
    <el-row style="margin-bottom: 10px"
            v-if="showPopover">
      <el-col :span="tabTitle ? (14 - topRightSpan) : (24 - topRightSpan)">
        <div style="width: 100%;height: 28px;">
          <slot name="tabButton"></slot>
        </div>
      </el-col>
      <el-col :span="10" v-if="tabTitle">
        <div style="width: 100%;height: 28px;">
          <slot name="tabTitle"></slot>
        </div>
      </el-col>
      <el-col :span="topRightSpan"
              style="text-align: right">
        <slot name="topRight"></slot>
        <!-- <el-tooltip class="item" effect="dark" 
                    :content="exportDataFn ? '导出查询结果' : '导出当前页'" placement="top">
          <el-button type="primary"
                     size="mini"
                     v-if="isExport"
                     icon="el-icon-document"
                     @click="exportExcel"></el-button>
        </el-tooltip> -->

        <!-- <el-button type="primary"
                   size="mini"
                   v-if="isScreen"
                   icon="el-icon-full-screen"
                   @click="screen"></el-button>
        <el-popover placement="bottom"
                    trigger="click"
                    v-if="isFilter"
                    @show="icon=false"
                    @hide="icon=true">
          <el-checkbox-group v-model="checkBoxVal"
                             class="fliterbox"
                             :min="1">
            <el-checkbox v-for="column in columnsOptions"
                         :label="column"
                         :key="column.labels">{{column.labels}}</el-checkbox>
          </el-checkbox-group>
          <el-button plain
                     slot="reference"
                     size="mini">
            <i class="iconfont icon-filter"></i>
          </el-button>
        </el-popover> -->
      </el-col>
    </el-row>
    <el-table :id="tableId"
              ref="mulTable"
              :stripe="stripe"
              :border="border"
              :height="height"
              :data="tableList"
              row-key="id"
              :max-height="maxHeight"
              @select="select"
              @row-dblclick="fn"
              @row-click="singleClick"
              @cell-click="cellclick"
              @sort-change="sortChange"
              @current-change="handleCurrentChange"
              @expand-change="expandChange"
              v-loading="dataListLoading"
              @selection-change="handleSelectionChange"
              :highlight-current-row="singleSelect"
              @select-all="selectAll"
              :show-summary="summary"
              :summary-method="getSummaries"
              :row-class-name="rowClassName"
              :cell-class-name="cellClassName"
              :span-method="mergeMethod">
      <el-table-column v-if="showContent"
                       type="expand">
        <template slot-scope="scope">
          <el-form label-position="left"
                   inline
                   class="demo-table-expand">
            <el-form-item label="消息内容：">
              <span>{{ scope.row[showField] }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column type="selection"
                       align="center"
                       v-if="showSelection"
                       :selectable="selectable">
      </el-table-column>
      <el-table-column width="20"
                       v-if="showSign"
                       fixed="left">
        <template slot-scope="scope">
          <slot name="sign"
                :row="scope.row"></slot>
        </template>
      </el-table-column>
      <el-table-column label="#"
                       width="40"
                       v-if="orderNofixed"
                       type="orderNumber"
                       :align="indexAlign">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="#"
                       width="40"
                       fixed="left"
                       v-if="showOrder"
                       type="orderNumber"
                       :align="indexAlign">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column v-for="(item, index) in ColumnArray"
                       :key="item.props + item.labels + index"
                       :prop="item.props"
                       :label="item.labels"
                       :sortable="item.sort"
                       :width="item.width"
                       :format="item.format"
                       :min-width="item.widths"
                       :align="item.align"
                       :show-overflow-tooltip="true">
        <template slot="header">
          <slot v-if="item.headSlot" :name="item.props + 'Head'"
                :item="item"></slot>
          <span v-else>{{item.labels}}</span>
        </template>
        <template slot-scope="scope">
          <div v-if="item.props =='status'|| item.props =='isEnabled'">
            <slot name="operators"
                  :row="scope.row"
                  :index="scope.$index"
                  :prop="item.props"></slot>
          </div>
          <span v-else-if="item.slot">
            <slot :name="item.props"
                  :row="scope.row"
                  :index="scope.$index"
                  :prop="item.props"></slot>
          </span>
          <!-- 判断是否转化为金额千分位保留两位小数显示 -->
          <div v-else-if="item.format === 'money'">{{ scope.row[item.props] | rounding | formatMoney }}</div>
          <!-- 判断是否转化为税率保留四位小数显示 -->
          <div v-else-if="item.format === 'rate'">{{ scope.row[item.props] | roundingRisk }}</div>
          <span v-else>{{ item.formatter ? item.formatter(scope.row) : scope.row[item.props] }}</span>
        </template>
      </el-table-column>
      <el-table-column type="expand"
                       label="价格趋势"
                       width="60"
                       fixed="right"
                       v-if="isRightExpand">
        <template slot-scope="scope">
          <slot name="rightExpand"
                :row="scope.row"
                :index="scope.$index"></slot>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       v-if="showEdit"
                       :width="widths"
                       align="left"
                       fixed="right">
        <template slot-scope="scope">
          <slot name="operator"
                :row="scope.row"
                :index="scope.$index"></slot>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
// import FileSaver from 'file-saver'
// import XLSX from 'xlsx'
import { getCookie } from '../../utils/index.js';
export default {
  name: 'tableCommon',
  props: {
    exportDataFn: { // 表格全部数据导出的接口
      type: Function,
    },
    exportColumn: {
      type: Array,
    },
    printId: { // 当页面有多个表格时需设置id传入
      type: String,
      default: ''
    },
    topRightSpan: {
      type: Number,
      default: 4
    },
    tableId: {
      type: String,
      default: 'subOutputRank-print'
    },
    orderNofixed: {
      type: Boolean,
      default: false
    },
    stripe: {
      type: Boolean,
      default: false
    },
    tabTitle: {
      type: Boolean,
      default: false
    },
    isRightExpand: {
      type: Boolean,
      default: false
    },
    showBlank: { // 是否显示一个空白列
      type: Boolean,
      default: true
    },
    showPopover: {// 是否表格头部功能栏
      type: Boolean,
      default: true
    },
    singleSelect: {
      type: Boolean,
      default: false
    },
    sortChange: {
      type: Function,
      default: function () { }
    },
    cellclick: {
      type: Function,
      default: function () { }
    },
    selectable: {
      type: Function,
      default: function (val) {
        if (Object.keys(val).length > 0) {
          return true
        } else {
          return false
        }
      }
    },
    select: {
      type: Function,
      default: function () {
      }
    },
    showField: { // 显示详情字段
      default: 'content'
    },
    selectAll: {
      type: Function,
      default: function () {
      }
    },
    indexAlign: {
      default: 'center'
    },
    fn: {
      type: Function,
      default: function () { }
    },
    singleClick: {
      type: Function,
      default: function () { }
    },
    handleSelectionChange: {
      type: Function,
      default: function () { }
    },
    handleCurrentChange: {
      type: Function,
      default: function () { }
    },
    handleSelectAll: {
      type: Function,
      default: function () { }
    },
    tableList: {
      type: Array
    },
    showOrder: {
      type: Boolean,
      default: true
    },
    showSign: {
      type: Boolean,
      default: false
    },
    showSelection: {
      type: Boolean,
      default: false
    },
    columnList: {
      type: Array
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    widths: {
      type: [String, Number],
      default: '70'
    },
    maxHeight: { // 表格最大高度
      type: [String, Number]
    },
    showContent: {
      type: Boolean,
      default: false
    },
    dataListLoading: {
      type: Boolean,
      default: false
    },
    height: {
      type: [String, Number]
    },
    border: {
      type: Boolean,
      default: true
    },
    isExport: {
      type: Boolean,
      default: true
    },
    isFilter: {
      type: Boolean,
      default: true
    },
    isScreen: {
      type: Boolean,
      default: false
    },
    summary: { // 是否在表尾显示合计行
      type: Boolean,
      default: false
    },
    getSummaries: { // 自定义合计计算方法
      type: Function,
      default: function () {
      }
    },
    mergeProp: { // 相等合并条件
      type: Array,
      default: () => {
        return []
      }
    },
    rowClassName: {
      type: Function,
      default: function () { },
    },
    cellClassName: {
      type: Function,
      default: function () { },
    }
  },
  data () {
    return {
      fullscreen: false,
      icon: true,
      merge: [],
      mergeList: [],
      ColumnArray: this.columnList,
      checkBoxVal: this.columnList,
      columnsOptions: this.columnList
    }
  },
  watch: {
    columnList: {
      handler (v) {
        this.ColumnArray = v
        this.checkBoxVal = v
        this.columnsOptions = v
      },
      deep: true
    },
    checkBoxVal (valArr) {
      this.ColumnArray = this.columnsOptions.filter(
        i => valArr.indexOf(i) >= 0
      )
    },
    tableList () {
      this.mergeCondition()
    }
  },
  // filters: {
  //   rounding (value) { // 显示两位小数
  //     if (value) {
  //       return Number(value).toFixed(2)
  //     } else {
  //       return value
  //     }
  //   }
  // },
  methods: {
    expandChange (row) {
      this.$emit('expand-change', {
        table: this.$refs.mulTable,
        row: row
      });
    },
    toggleSelection (row) {
      if (row) {
        this.$refs.mulTable.toggleRowSelection(row)
      } else {
        this.$refs.mulTable.clearSelection()
      }
    },
    clearSelection () {
      this.$refs.mulTable.clearSelection()
    },
    formatJson (val, jsonData) {
      return jsonData.map((v) => val.map((j) => v[j]));
    },
    // exportExcel () {
    //   if (this.exportDataFn) {
    //     this.exportDataFn()
    //     return
    //   }
    //   let exportColumn = _.cloneDeep(this.exportColumn || this.ColumnArray)
    //   import("@/assets/js/excel/Export2Excel").then((excel) => {
    //     let tHeader = exportColumn.filter((item) => item.labels).map(
    //       (head) => head.labels
    //     );
    //     let tField = exportColumn.filter((item) => item.labels).map(
    //       (head) =>head.props
    //     );
    //     let list = this.tableList;
    //     let data = this.formatJson(tField, list);
    //     excel.export_json_to_excel({
    //       header: tHeader,
    //       data,
    //       filename: "数据导出",
    //       autoWidth: true,
    //     });
    //   });
    // },
    // 合并条件初始化
    mergeCondition () {
      this.mergeList = []
      this.merge = []
      let oldFieldData = null
      for (let i = 0; i < this.columnList.length; i++) {
        if (this.columnList[i].isMerge) {
          this.merge.push(this.columnList[i].props)
        }
      }
      this.getMergeArr(this.tableList, this.merge)
    },
    // 构造单元格占用行
    getMergeArr (tableData, merge) {
      if (!merge) {
        return
      }
      this.mergeLine = {}
      this.mergeIndex = {}
      let oldFieldData = null
      merge.forEach((item, k) => {
        tableData.forEach((data, i) => {
          if (i === 0) {
            this.mergeIndex[item] = this.mergeIndex[item] || []
            this.mergeIndex[item].push(1)
            this.mergeLine[item] = 0
          } else if (this.mergeProp.includes(item) && item !== this.mergeProp[this.mergeProp.length - 1]) {
            if (tableData[i - 1][item] === data[item]) {
              this.mergeIndex[item][this.mergeLine[item]] += 1
              this.mergeIndex[item].push(0)
            } else {
              this.mergeIndex[item].push(1)
              this.mergeLine[item] = i
            }
          } else {
            if (tableData[i - 1][this.mergeProp[this.mergeProp.length - 1]] === data[this.mergeProp[this.mergeProp.length - 1]] &&
              this.checkBefore(tableData, i, data)) {
              this.mergeIndex[item][this.mergeLine[item]] += 1
              this.mergeIndex[item].push(0)
            } else {
              this.mergeIndex[item].push(1)
              this.mergeLine[item] = i
            }
          }
        })
      })
    },
    checkBefore (tableData, i, data) {
      for (let index = 0; index < this.mergeProp.length - 1; index++) {
        if (tableData[i - 1][this.mergeProp[index]] !== data[this.mergeProp[index]]) {
          return false
        }
      }
      return true
    },
    mergeMethod ({ row, column, rowIndex, columnIndex }) {
      if (this.mergeProp.length === 0) {
        return
      }
      const index = this.merge.indexOf(column.property)
      if (index > -1) {
        const _row = this.mergeIndex[this.merge[index]][rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    screen () {
      let element = document.getElementById('customer_data_screen')// 设置后就是   id==con_lf_top_div 的容器全屏
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen()
        }
      }
      this.fullscreen = !this.fullscreen
    }
  }
}
</script>

<style lang="scss">
.list-common {
  .el-col {
    .icon-svg {
      width: 10px;
      height: 10px;
    }
  }
  .cell {
    padding-left: 4px;
    padding-right: 4px;
  }
  .is-center .cell {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>

<style lang="scss">
.list-common{
  .el-table--border .el-table__cell:first-child .cell{
    padding-left: 0;
  }
  .el-table thead{
    font-weight: normal;
  }
  .el-table thead th, .el-table th.el-table__cell{
    background: #cde7fc;
  }
  .el-table .el-table__cell{
    padding: 8px 0;
  }
  .el-table th.el-table__cell>.cell{
    padding-left: 2px;
    padding-right: 2px;
    font-weight: normal;
    color: #000;
  }
  .el-table td.is-center .cell,
  .el-table th.is-center .cell {
    padding: 0;
  }
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/list-common.vue